<template>
    <div class="containerRepresentante">
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="titleForm" style="display: inline-flex">
                <div style="width: 90%">
                    <LabelDisclaimer :TamanhoFonteLabel="'H3'" :NomeLabel="'Procuradores'" :TipoCliente="'Fundos'"
                        :Sessao="'Procuradores'" :SubSessao="'Procuradores'" />
                    <h5>Clique em adicionar se possuir procuradores. Você pode adicionar quantas pessoas desejar.</h5>
                </div>
            </div>
            <div class="resumoForm">
                <div class="opcoesForm" v-if="listaRepresentantes?.length == 0">
                    <div v-if="!consultaProgresso">
                        <img src="@/assets/addRepresentante.png" />
                        <h3>Nenhuma pessoa adicionada</h3>
                    </div>
                    <div v-if="consultaProgresso" class="spinner"></div>
                </div>
                <div v-if="listaRepresentantes?.length > 0">

                    <table class="table desktop">
                        <thead>
                            <th style="width: 20%">Nome e E-mail</th>
                            <th style="width: 15%">CPF/CNPJ</th>
                            <th style="width: 15%">Emissor de Ordem</th>
                            <th style="width: 15%">US Person</th>
                            <th style="width: 15%">Politicamente exposta</th>
                            <th style="width: 15%">Assinatura</th>
                            <th style="width: 20%">&nbsp;</th>
                        </thead>
                        <tbody>
                            <tr v-for="(representanteObj, index) in listaRepresentantes" :key="index">
                                <td><span class="destaque">{{ representanteObj.Nome }} </span> {{ representanteObj.Email
                                    }}</td>
                                <td>{{ formatCpfCnpj(representanteObj.Cpf) }}</td>
                                <td>{{ representanteObj.EmissorOrdem == true ? "Sim" : "Não" }}</td>
                                <td>{{ representanteObj.UsPerson == true ? "Sim" : "Não" }}</td>
                                <td>{{ representanteObj.PoliticamenteExposta == true ? "Sim" : "Não" }}</td>
                                <td>{{ representanteObj.AssinaturaFormatada }}</td>
                                <td>
                                    <div class="widget icons" style="display: inline-flex">
                                        <a @click.stop.prevent="editarRepresentante(index)" class="ico__edit"
                                            title="editar">
                                            <Icon icon="ico-edit" />
                                        </a>
                                        <!-- v-if="politicaSelecionada == null || (politicaSelecionada != null && politicaSelecionada.guid == item.guid)" -->
                                        <a 
                                            @click.stop.prevent="deletarRepresentante(index)" class="ico__delete"
                                            title="deletar" style="margin-left: 5px"></a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Dados procurador'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Representantes'" :SubSessao="'Representantes'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 60%">

                            <InputNome 
                                v-model="representante.Nome"
                                label="Nome"
                                :required="true"
                                :erro="camposObrigatorios.erroNome"
                            />


                        </div>
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="cpf">CPF/CNPJ*</label>
                            <input class="field" type="text" id="cpf" v-model="representante.Cpf">
                            <p v-if="camposObrigatorios.erroCpf" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="nome">E-mail*</label>
                            <input class="field" type="text" id="email" v-model="representante.Email" @blur="validarEmail">
                            <p v-if="emailErros.email" class="erro">{{ emailErros.email }}</p>
                        </div>
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="cpf">Cargo</label>
                            <input class="field" type="text" id="cargo" v-model="representante.Cargo">
                        </div>
                        <div class="label__field" style="width: 30%">

                                <telefone-internacional 
                                    v-model="representante.Telefone" 
                                    label="Telefone" 
                                    :name="'Telefone'"
                                    :opcional="true"
                                    @validate="onValidateTelefone"
                                />

                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 10%">
                            <label class="label" for="nome">CEP*</label>
                            <input class="field" type="text" id="cep" v-model="representante.Cep"
                                @change="validarCep(representante)">
                            <p v-if="camposObrigatorios.erroCep" class="erro">Campo obrigatório.</p>
                        </div>
                        <div class="custom-link" style="width: 8%; margin-top: 35px;">
                            <a target="_blank" href="https://buscacepinter.correios.com.br/app/endereco/index.php">Não sei o CEP</a>
                        </div>
                        <div class="label__field" style="width: 67%">
                            <label class="label" for="cpf">Endereço/Logradouro*</label>
                            <input class="field" type="text" :disabled="isDisabledEnderecoLogradouro" id="endereco"
                                v-model="representante.Logradouro">
                            <p v-if="camposObrigatorios.erroLogradouro" class="erro">Campo obrigatório.</p>
                        </div>
                        <div class="label__field" style="width: 10%">
                            <label class="label" for="cpf">Número*</label>
                            <input class="field" type="text" id="numero" v-model="representante.Numero">
                            <p v-if="camposObrigatorios.erroNumero" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="nome">Complemento</label>
                            <input class="field" type="text" id="complemento" v-model="representante.Complemento">
                        </div>
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="cpf">Bairro*</label>
                            <input class="field" :disabled="isDisabledEndereco" type="text" id="bairro"
                                v-model="representante.Bairro">
                            <p v-if="camposObrigatorios.erroBairro" class="erro">Campo obrigatório.</p>
                        </div>
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="cpf">Cidade*</label>
                            <input class="field" :disabled="isDisabledEndereco" type="text" id="cidade"
                                v-model="representante.Cidade">
                            <p v-if="camposObrigatorios.erroCidade" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 20%">
                            <label class="label" for="nome">UF*</label>
                            <select class="field" :disabled="isDisabledEndereco" id="uf" v-model="representante.Uf">
                                <option value="null">Selecione</option>
                                <option v-for="uf in ufs" :key="uf" :value="uf">
                                    {{ uf }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroUF" class="erro">Campo obrigatório.</p>
                        </div>
                        <div class="label__field" style="width: 20%">
                            <label class="label" for="nome">País*</label>
                            <select id="pais" class="field"
                                v-model="representante.Pais" :disabled="isDisabledEndereco" >
                                <option value="">Selecione</option>
                                <option v-for="item in listaPaises" :key="item.Codigo" :value="item.Codigo">
                                    {{ item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroPais" class="erro">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 20%">
                            <div class="form__controls" style="width: 100%">
                                <label class="label" for="nome">Considerado US Person?*</label>
                                <div class="radio">
                                    <input type="radio" id="false" name="UsPerson" class="field__radio" value="false"
                                        v-model="representante.UsPerson" />
                                    <label for="Nao" class="label__radio">Não</label>
                                    <input type="radio" id="true" value="true" name="UsPerson"
                                        class="field__radio field__radio_second" v-model="representante.UsPerson" />
                                    <label for="Sim" class="label__radio">Sim</label>
                                </div>
                            </div>
                        </div>
                        <div class="label__field" style="width: 20%">
                            <div class="form__controls" style="width: 100%">
                                <label class="label" for="nome">Politicamente Exposto?*</label>
                                <div class="radio">
                                    <input type="radio" id="false" name="PoliticamenteExposta" class="field__radio"
                                        value="false" v-model="representante.PoliticamenteExposta" />
                                    <label for="Nao" class="label__radio">Não</label>
                                    <input type="radio" id="true" value="true" name="PoliticamenteExposta"
                                        class="field__radio field__radio_second"
                                        v-model="representante.PoliticamenteExposta" />
                                    <label for="Sim" class="label__radio">Sim</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="assinante">Assinatura*</label>
                            <select id="assinante" class="field" v-model="representante.Assinatura">
                                <option value=""></option>
                                <option value="1">Não assina pela empresa</option>
                                <option value="2">Assina isoladamente</option>
                                <option value="0">Assina em conjunto</option>
                            </select>
                            <p v-if="camposObrigatorios.erroAssinatura" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="buttonsAcoes" style="margin-bottom: 10px;">
                        <button class="btnDefault" type="button" style="width: 80px; height: 40px;"
                            @click="limparRepresentante">Cancelar</button>
                        <button class="btnBlue" type="button" v-if="representante.Guid == ''"
                            :disabled="disableBtnSalvarRepresentante" @click="incluirPessoa">Adicionar</button>
                        <button class="btnBlue" type="button" v-if="representante.Guid != ''"
                            :disabled="disableBtnSalvarRepresentante" @click="incluirPessoa">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import emailValidatorMixin from '@/utils/emailValidatorMixin.js';
import { mapGetters } from 'vuex';
import formatCpfCnpj from '@/utils/formatCpfCnpj'
import LabelDisclaimer from '@/components/LabelDisclaimer.vue'
import api from '@/api/axios';
import { validarCampoCep, ufs } from '@/utils/formUtils';

import { confirmarReassinatura } from "@/utils/confirmarReassinatura";
import { verificarDocumentoAtivo } from "@/utils/verificarDocumentoAtivo";

export default {
    name: 'CadastroFI_Procuradores',
    props: ['Edicao'],
    mixins: [formatCpfCnpj, emailValidatorMixin],
    components: { LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaRepresentantes: 'GET_LISTA_PROCURADORES_FI',
            listaPaises: 'GET_LISTA_PAISES',
        }),
        celularMask() {
            const telefoneLimpo = this.representante.Telefone?.replace(/\D/g, '');
            if (telefoneLimpo?.length <= 11) {
                return '(##) #####-####';
            }
            else {
                return '+(##) (##) ####-#####';
            }
        },
        ufs() {
            return ufs;
        },
    },
    data() {
        return {
            telefoneValido: [],
            emailErros: {},
            permitirAvancar: false,
            camposObrigatorios: {
                erroNome: false,
                erroCpf: false,
                erroEmail: false,
                erroTelefone: false,
                erroCep: false,
                erroLogradouro: false,
                erroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroUF: false,
                erroPais: false,
                erroAssinatura: false
            },
            disableBtnSalvarRepresentante: false,
            isDisabledEndereco: false,
            isDisabledEnderecoLogradouro: false,
            consultaProgresso: true,
            representante: {
                Guid: '',
                Nome: '',
                Cpf: '',
                Email: '',
                Cargo: '',
                Telefone: '',
                Cep: '',
                Logradouro: '',
                Numero: '',
                Complemento: '',
                Bairro: '',
                Cidade: '',
                Uf: '',
                Pais: '',
                Tipo: 'Procurador',
                EmissorOrdem: false,
                UsPerson: false,
                PoliticamenteExposta: false,
                Assinatura: ''
            },
        }
    },
    mounted() {
        this.$store.commit('SET_MODAL_PJ_ADD_PESSOA', false);
        if(this.listaRepresentantes != null){
            this.consultaProgresso = false;
        }

    },
    watch: {
        listaRepresentantes() {
            this.consultaProgresso = false;
        }
    },
    methods: {
        onValidateTelefone({ name, valid }) {
            if (!this.telefoneValido) {
                this.telefoneValido = {};
            }
            if(valid != 'undefined'){
                this.telefoneValido[name] = valid;
            }
        },
        validarEmail() {
            this.validarEmailGeneric(this.representante.Email, 'email', {
                obrigatorio: true,
            });
        },
        async validarCep(objDados, somenteValidar = false) {
            var result = await validarCampoCep(objDados, { somenteValidar: somenteValidar });
            if (result) {
                this.isDisabledEndereco = true;
                this.isDisabledEnderecoLogradouro = true;
                if (objDados.Logradouro == '') {
                    this.isDisabledEnderecoLogradouro = false;
                }
            } else {
                this.isDisabledEndereco = false;
                this.isDisabledEnderecoLogradouro = false;
            }
        },
        proximaEtapa() {
            this.salvarInformacoes();
            this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
            this.$store.commit('SET_ETAPA_CADASTRO', 2);

        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            var valorInvalido = false;

            this.camposObrigatorios = {
                erroNome: false,
                erroCpf: false,
                erroEmail: false,
                erroTelefone: false,
                erroCep: false,
                erroLogradouro: false,
                erroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroUF: false,
                erroPais: false,
                erroAssinatura: false
            };
            if (!this.representante.Nome) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroNome = true;
                    nomeDoCampo = 'Nome';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Cpf && nomeDoCampo == "") {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroCpf = true;
                    nomeDoCampo = 'CPF/CNPJ';
                }
                this.permitirAvancar = false;
            }
            if (Object.values(this.emailErros).some(erro => erro !== '') && nomeDoCampo == "") {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEmail = true;
                    nomeDoCampo = 'E-mail';
                }
                this.permitirAvancar = false;
            }

                const telefoneValido = this.telefoneValido[`Telefone`];

                if (this.representante.Telefone.length > 4  && nomeDoCampo == ""
                && (!this.representante.Telefone || telefoneValido == false)) {
                    if (submeter && this.permitirAvancar) {
                        nomeDoCampo = 'Telefone';
                    }
                    if(telefoneValido== false){
                        valorInvalido = true;
                    }
                    this.permitirAvancar = false;
                }



            if (!this.representante.Cep && nomeDoCampo == "") {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroCep = true;
                    nomeDoCampo = 'CEP';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Logradouro && nomeDoCampo == "") {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroLogradouro = true;
                    nomeDoCampo = 'Logradouro';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Numero && nomeDoCampo == "") {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroNumero = true;
                    nomeDoCampo = 'Numero do endereço';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Bairro && nomeDoCampo == "") {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroBairro = true;
                    nomeDoCampo = 'Bairro';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Cidade && nomeDoCampo == "") {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroCidade = true;
                    nomeDoCampo = 'Cidade';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Uf && nomeDoCampo == "") {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroUF = true;
                    nomeDoCampo = 'UF';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Pais && nomeDoCampo == "") {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroPais = true;
                    nomeDoCampo = 'País';
                }
                this.permitirAvancar = false;
            }
            if (this.representante.Assinatura === null || this.representante.Assinatura === undefined || this.representante.Assinatura === '') {
                if (submeter && this.permitirAvancar && nomeDoCampo == "") {
                    this.camposObrigatorios.erroAssinatura = true;
                    nomeDoCampo = 'Assinatura';
                }
                this.permitirAvancar = false;
            }
            if (submeter && nomeDoCampo != '') {
                if(valorInvalido){

                    this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo ` + nomeDoCampo + ` foi informado, mas não foi preenchido corretamente. Preencha a informação para avançar.`,
                });

                }else{
                    this.$swal({
                        icon: 'warning',
                        title: 'Oops...',
                        text: `O campo ` + nomeDoCampo + ` não foi informado ou é inválido, preencha a informação para avançar.`,
                    });
                }
            }

            return this.permitirAvancar;
        },
        salvarInformacoes() {
            this.$store.commit('SET_FI_SALVAR_INFO', true);
            //this.incluirPessoa();
        },
        async incluirPessoa() {
            //this.$store.commit('SET_MODAL_PJ_ADD_PESSOA', true);
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.disableBtnSalvarRepresentante = true;

                if((this.representante.Guid == '' && String(this.representante.Assinatura) != '1') || 
                    this.representante.Guid != '')
                {
                    var documentoAtivo = await verificarDocumentoAtivo();

                    if (documentoAtivo) {
                        var confirmado = await confirmarReassinatura();
                        if (!confirmado){ 
                            this.disableBtnSalvarRepresentante = false;
                            return;
                        }
                    }
                }
                 
                await api
                    .post('/Fundo/procurador', this.representante)
                    .then((retorno) => {
                        this.disableBtnSalvarRepresentante = false;
                        if (retorno.status == 200) {
                            this.$swal({
                                icon: 'success',
                                title: this.representante.Guid == '' ? 'Inclusão realizada com sucesso!' : 'Alteração realizada com sucesso!',
                                text: 'Dados informados foram salvos com sucesso.',
                            });
                            this.limparRepresentante();
                            this.$store.dispatch('FETCH_FI_LISTA_PROCURADORES');
                        }
                    })
                    .catch((error) => {
                        this.disableBtnSalvarRepresentante = false;
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos para procurador.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            }
        },
        editarRepresentante(index) {
            this.representante = JSON.parse(JSON.stringify(this.listaRepresentantes[index]));
            this.validarCep(this.representante, true);
            this.validarEmail();
        },
        limparRepresentante() {
            this.representante.Guid = '';
            this.representante.Nome = '';
            this.representante.Cpf = '';
            this.representante.Email = '';
            this.representante.Cargo = '';
            this.representante.Telefone = '';
            this.representante.Cep = '';
            this.representante.Logradouro = '';
            this.representante.Numero = '';
            this.representante.Complemento = '';
            this.representante.Bairro = '';
            this.representante.Cidade = '';
            this.representante.Uf = '';
            this.representante.Pais = '';
            this.representante.Tipo = 'Procurador';
            this.representante.EmissorOrdem = false;
            this.representante.UsPerson = false;
            this.representante.PoliticamenteExposta = false;
            this.representante.Assinatura = '';
            this.camposObrigatorios = {
                erroNome: false,
                erroCpf: false,
                erroEmail: false,
                erroTelefone: false,
                erroCep: false,
                erroLogradouro: false,
                erroNumero: false,
                erroBairro: false,
                erroCidade: false,
                erroUF: false,
                erroPais: false,
                erroAssinatura: false,
            };
            this.isDisabledEndereco = false;
            this.isDisabledEnderecoLogradouro = false;
        },
        async deletarRepresentante(index) {
            this.disableBtn = true;

            if(String(this.listaRepresentantes[index].Assinatura) != '1')
            {
                var documentoAtivo = await verificarDocumentoAtivo();

                if (documentoAtivo) {
                    var confirmado = await confirmarReassinatura();
                    if (!confirmado){ 
                        this.disableBtn = false;
                        return;
                    }
                }
            }
             
            await api.get(`Fundo/procurador/excluir?guid=${this.listaRepresentantes[index].Guid}`)
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$swal({
                            icon: 'success',
                            title: 'Exclusão realizada com sucesso!',
                            text: 'Dados informados foram excluídos com sucesso.',
                        });
                        this.$store.dispatch('FETCH_FI_LISTA_PROCURADORES');
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos.',
                        text: `${error.response.data.data[0]}`,
                    });
                });
        }
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.field__radio {
    margin-top: -2px;
    width: 20px;
    height: 20px;
}

// .btnBlueUpload {
//     height: 40px;
//     font-family: 'Inter', sans-serif;
//     /* Fonte Inter */
//     background-color: #00235C;
//     border: 1px solid #00235C;
//     /* Borda */
//     border-radius: 8px;
//     /* Raio de borda */
//     widows: 88px;
//     cursor: pointer;
// }

// .formulario {
//     margin-top: 20px;
//     width: 100%;
//     margin-bottom: 10px;
//     font-family: 'Inter', sans-serif;
//     /* Fonte Inter */
//     border: 1px solid #EAECF0;
//     border-radius: 8px;
//     /* Raio de borda */

//     .titleForm {
//         background-color: white;
//         border-bottom: 1px solid #EAECF0;
//         width: 100%;

//         .btnBlue {
//             height: 40px;
//             font-family: 'Inter', sans-serif;
//             /* Fonte Inter */
//             background-color: #00235C;
//             color: white;
//             border: 1px solid #00235C;
//             /* Borda */
//             border-radius: 8px;
//             /* Raio de borda */
//             width: 100px;
//             cursor: pointer;
//         }

//         h3 {
//             margin-left: 20px;
//             color: #101828;
//             font-weight: 500;
//             font-family: 'Inter', sans-serif;
//         }

//         h5 {
//             margin-top: 5px;
//             margin-left: 20px;
//             margin-block-start: 0;
//             color: #667085;
//             font-weight: 500;
//             font-family: 'Inter', sans-serif;
//         }
//     }

//     .resumoForm {
//         width: 100%;

//         .opcoesForm {
//             display: grid;
//             justify-content: center;
//             align-content: center;
//             align-items: center;
//             justify-items: center;
//             padding: 30px 0px 30px 0px;

//             h5 {
//                 margin-top: 5px;
//                 margin-block-start: 0;
//                 color: #667085;
//                 font-weight: 500;
//                 font-family: 'Inter', sans-serif;
//             }

//             img {
//                 height: 48px;
//                 width: 48px;
//             }

//             .btnBlue {
//                 height: 40px;
//                 font-family: 'Inter', sans-serif;
//                 /* Fonte Inter */
//                 background-color: #00235C;
//                 color: white;
//                 border: 1px solid #00235C;
//                 /* Borda */
//                 border-radius: 8px;
//                 /* Raio de borda */
//                 width: 350px;
//                 cursor: pointer;
//             }
//         }
//     }
// }

// .agrupamentoFormulario {
//     width: 100%;
//     display: inline-flex;
//     margin-top: 10px;
// }

// .categoriaAgrupamentoFormulario {
//     width: 13%;
//     margin-right: 15px;
//     font-family: 'Inter', sans-serif;
//     /* Fonte Inter */

//     span {
//         font-weight: 400 !important;
//         font-size: 13px;
//         color: #667085;
//     }
// }

// .label__field {
//     padding-right: 30px;
// }

// .camposAgrupamentoFormulario {
//     width: 90%;

//     .row {
//         width: 100%;
//         display: inline-flex;
//         gap: 8px;
//         margin-bottom: 10px;
//     }

//     .accept {
//         display: inline-flex;
//         &:checked {
//             +label {
//                 &:before {
//                     background: white;
//                     border: 1px solid black;
//                     transition: background 0.3s;
//                 }
//             }

//             +label {
//                 &::after {
//                     opacity: 1;
//                     transition: all;
//                     background: transparent;
//                 }
//             }
//         }
//     }

//     .radio {
//         display: flex;
//         align-items: center;
//         margin-right: 25px;
//         @media (max-width: 768px) {
//             margin-right: 0;
//             margin-bottom: 20px;
//         }

//         .field__radio {
//             margin-top: -2px;
//             width: 20px;
//             height: 20px;
//         }

//         .fieldInRadio {
//             border-radius: 8px;
//             /* Raio de borda */
//             border: 1px solid #D0D5DD;
//             /* Borda */
//             padding: 10px 14px;
//             /* Preenchimento interno */
//             background-color: #F9FAFB;
//             /* Cor de fundo */
//             width: 55%;
//         }

//         .label__radio {
//             margin-left: 5px;
//             margin-right: 40px;
//             margin-top: 5px;
//         }
//     }

//     select {
//         width: 105% !important;
//     }


//     label {
//         font-family: 'Inter', sans-serif;
//         /* Fonte Inter */
//         font-weight: 500;
//         /* Peso médio */
//         font-size: 14px;
//         /* Tamanho da fonte */
//         line-height: 20px;
//         /* Altura da linha */
//         color: #344054;
//         /* Cor */
//         display: block;
//         /* Garante que a label fique acima do input */
//         margin-bottom: 8px;
//         /* Espaçamento entre a label e o input abaixo dela */
//     }
// }

// .title {

//     border-bottom: 1px solid #EAECF0;

//     h3 {
//         margin-top: 50px;
//         color: #101828;
//         font-weight: 500;
//         font-family: 'Inter', sans-serif;
//     }

//     h5 {
//         margin-top: 5px;
//         margin-block-start: 0;
//         color: #667085;
//         font-weight: 400;
//         font-family: 'Inter', sans-serif;
//     }
// }</style>